





























































































































































































































































































































































































































































































































































































































































































import {
  BidManagementBidService as bidApi,
  MemberManagementMemberAddressService as memberAddressApi,
} from "@/common/api";
import { DATE_TIME_FORMAT } from "@/common/constant";
import QCalendar from "@/common/qCalendar.vue";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import { compareWithKeys } from "@/common/utils";
import { formatImageUrl } from "@/common/utils";
import PostalCode from "@/components/common/postalCode.vue";
import QEditor from "@/components/common/qEditor.vue";
import QInput from "@/components/common/qInput.vue";
import QLanguageBox from "@/components/common/qLanguageBox.vue";
import QLanguageTab from "@/components/common/qLanguageTab.vue";
import QReleaseSettingSendMail from "@/components/common/qReleaseSettingSendMail.vue";
import uploadFile from "@/components/common/uploadFile.vue";
import {
  DELIVERY_PREFERRED_TIME_NAME,
  PAYMENT_TYPES,
  PAYMENT_TYPES_NAME,
  STATUS_NAME_LIVECARP,
  STATUSES,
} from "@/model/order";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const noImage = require("@/assets/images/muuq-base/noimage.svg");

@Component({
  name: "BidDetailComponent",
  components: {
    QErrors,
    QLanguageTab,
    QLanguageBox,
    QReleaseSettingSendMail,
    QEditor,
    uploadFile,
    PostalCode,
    QCalendar,
    QInput,
  },
})
export default class BidDetailComponent extends Vue {
  public isShow = false;
  public orderId = null;

  public errors = {};
  public errorStyle = {
    maxWidth: "100%",
    display: "flex",
  };

  public dateConfig = {
    enableTime: false,
    dateFormat: "Y-m-d",
    defaultHour: 0,
  };

  public initOrder: any = {
    order_code: null,
    member_id: null,
    type: null,
    invoice_name: null,
    invoice_zip: null,
    invoice_address1: null,
    invoice_address2: null,
    invoice_address3: null,
    invoice_tel: null,
    destination_name: null,
    destination_zip: null,
    destination_address1: null,
    destination_address2: null,
    destination_address3: null,
    destination_tel: null,
    delivery_preferred_date: null,
    delivery_preferred_time: null,
    note: null,
    payment_type: null,
    payment_limit_date: null,
    status: null,
    note_staff: null,
    member: {},
    order_units: [],
  };

  public order: any = JSON.parse(JSON.stringify(this.initOrder));
  public originalOrder;
  public invoiceAddress = null;
  public destinationAddress = null;
  public memberAddress = [];
  public usedPointOld = 0;
  public otherId = -1;
  public defaultId = 0;
  public statusBefore = null;

  get statusOptions() {
    return STATUS_NAME_LIVECARP;
  }

  get paymentMethodOptions() {
    return PAYMENT_TYPES_NAME;
  }

  get deliveryPreferredTimeOptions() {
    return DELIVERY_PREFERRED_TIME_NAME;
  }

  get addtionalPriceTotal() {
    return this.sumAmount(
      this.order.order_units.filter((unit) =>
        Number.parseInt(unit.addtional_price),
      ),
      "addtional_price",
    );
  }

  get addtinals() {
    return this.order.order_units.filter((unit) =>
      Number.parseInt(unit.addtional_price),
    );
  }

  public sumAmount(target, type) {
    let sum = 0;
    for (const unit of target) {
      sum += Number.parseInt(unit[type] ? unit[type] : 0);
    }
    return sum;
  }

  public async show(orderId) {
    this.clearOrder();
    this.isShow = true;
    if (orderId) {
      this.orderId = orderId;
      await this.getDetail();
      this.usedPointOld = Number.parseInt(this.order.used_points)
        ? Number.parseInt(this.order.used_points)
        : 0;
      await this.getMemberAddress();
      this.showAddress();
    }

    this.originalOrder = { ...this.order };

    this.$el.querySelector(".bidDetailPopup").scrollTop = 0;
  }

  public async getMemberAddress() {
    const result = await memberAddressApi.adminMemberAddress({
      memberId: this.order.member_id,
    });

    this.memberAddress = result.data.MemberAddress;
  }

  public showAddress() {
    const invoiceAddress = this.memberAddress.find(
      (address) =>
        address.name === this.order.invoice_name &&
        address.zip === this.order.invoice_zip &&
        address.address1 === this.order.invoice_address1 &&
        address.address2 === this.order.invoice_address2 &&
        (address.address3 || "") === (this.order.invoice_address3 || "") &&
        address.tel === this.order.invoice_tel,
    );
    if (invoiceAddress) {
      this.invoiceAddress = invoiceAddress.id;
    } else {
      const name =
        this.order.member.last_name + " " + this.order.member.first_name;
      if (
        this.order.invoice_name == name &&
        this.order.invoice_zip == this.order.member.zip &&
        this.order.invoice_address1 == this.order.member.address1 &&
        this.order.invoice_address2 == this.order.member.address2 &&
        (this.order.invoice_address3 || "") ==
          (this.order.member.address3 || "") &&
        this.order.invoice_tel == this.order.member.tel
      ) {
        this.invoiceAddress = this.defaultId;
      } else {
        this.invoiceAddress = this.otherId;
      }
    }

    const destinationAddress = this.memberAddress.find(
      (address) =>
        address.name === this.order.destination_name &&
        address.zip === this.order.destination_zip &&
        address.address1 === this.order.destination_address1 &&
        address.address2 === this.order.destination_address2 &&
        (address.address3 || "") === (this.order.destination_address3 || "") &&
        address.tel === this.order.destination_tel,
    );
    if (destinationAddress) {
      this.destinationAddress = destinationAddress.id;
    } else {
      const name =
        this.order.member.last_name + " " + this.order.member.first_name;
      if (
        this.order.destination_name == name &&
        this.order.destination_zip == this.order.member.zip &&
        this.order.destination_address1 == this.order.member.address1 &&
        this.order.destination_address2 == this.order.member.address2 &&
        (this.order.destination_address3 || "") ==
          (this.order.member.address3 || "") &&
        this.order.destination_tel == this.order.member.tel
      ) {
        this.destinationAddress = this.defaultId;
      } else {
        this.destinationAddress = this.otherId;
      }
    }
  }
  public changeInput(key) {
    if (this.errors[key]) {
      this.errors = { ...this.errors, ...{ [key]: [] } };
    }
  }

  public pushError(message) {
    this.errors = {
      ...this.errors,
      ...{ uploadFiles: message },
    };
  }

  public async getDetail() {
    const result = await bidApi.adminBidShow({
      id: this.orderId,
    });

    this.order = result.data.order;
    this.statusBefore = this.order.status;
  }

  public async submit() {
    let parameters: any = {};
    let result;
    try {
      parameters = {
        id: this.orderId,
        invoiceMemberAddressid:
          this.invoiceAddress == this.defaultId ||
          this.invoiceAddress == this.otherId
            ? null
            : this.invoiceAddress,
        invoiceName: this.order.invoice_name,
        invoiceZip: this.order.invoice_zip,
        invoiceAddress1: this.order.invoice_address1,
        invoiceAddress2: this.order.invoice_address2,
        invoiceAddress3: this.order.invoice_address3,
        invoiceTel: this.order.invoice_tel,
        destinationMemberAddressid:
          this.destinationAddress == this.defaultId ||
          this.destinationAddress == this.otherId
            ? null
            : this.destinationAddress,
        destinationName: this.order.destination_name,
        destinationZip: this.order.destination_zip,
        destinationAddress1: this.order.destination_address1,
        destinationAddress2: this.order.destination_address2,
        destinationAddress3: this.order.destination_address3,
        destinationTel: this.order.destination_tel,
        orderUnits: this.order.order_units.map((orderUnit) => {
          return {
            id: orderUnit.id,
            shippingNumber: orderUnit.shipping_number,
            postage: orderUnit.postage,
            addtionalName: orderUnit.addtional_name,
            addtionalPrice: orderUnit.addtional_price,
          };
        }),
        usePoint: this.order.used_points,
        paymentType: this.order.payment_type,
        paymentLimitDate: this.order.payment_limit_date,
        deliveryPreferredDate: this.order.delivery_preferred_date,
        deliveryPreferredTime: this.order.delivery_preferred_time,
        note: this.order.note,
        status: this.order.status,
        noteStaff: this.order.note_staff,
      };

      result = await bidApi.adminBidEdit(parameters);

      QNotify.success({
        text: this.$t("common.message.updated"),
      });
      if (
        this.statusBefore != this.order.status &&
        (this.order.status == STATUSES.INITIAL ||
          this.statusBefore == STATUSES.INITIAL)
      ) {
        window.dispatchEvent(new CustomEvent("reload-notice"));
      }
      this.closePopup();
    } catch (error: any) {
      result = error.body;
      this.errors = result.errors;
      if (Object.keys(this.errors).length === 0) {
        this.errors = {
          ...this.errors,
          ...{ memberPoint: error.body.message },
        };
      }
    }
  }

  public cancel() {
    // check modifier order.
    const diff = compareWithKeys(
      this.order,
      this.originalOrder,
      [
        "order_code",
        "member_id",
        "type",
        "invoice_name",
        "invoice_zip",
        "invoice_address1",
        "invoice_address2",
        "invoice_address3",
        "invoice_tel",
        "destination_name",
        "destination_zip",
        "destination_address1",
        "destination_address2",
        "destination_address3",
        "destination_tel",
        "delivery_preferred_date",
        "delivery_preferred_time",
        "note",
        "payment_type",
        "payment_limit_date",
        "status",
        "note_staff",
        "order_units",
      ],
      true,
    );

    if (!diff) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.isShow = false;
        },
      });
    } else {
      this.isShow = false;
    }
  }

  public closePopup() {
    this.clearOrder();
    this.isShow = false;
    this.$emit("close");
  }

  public clearOrder() {
    this.orderId = null;
    this.order = JSON.parse(JSON.stringify(this.initOrder));
    this.errors = {};
  }

  public changeInvoiceAddress() {
    if (this.invoiceAddress == this.defaultId) {
      this.order.invoice_name =
        this.order?.member?.last_name + " " + this.order?.member?.first_name;
      this.order.invoice_zip = this.order?.member?.zip;
      this.order.invoice_address1 = this.order?.member?.address1;
      this.order.invoice_address2 = this.order?.member?.address2;
      this.order.invoice_address3 = this.order?.member?.address3;
      this.order.invoice_tel = this.order?.member?.tel;
    } else {
      const address = this.memberAddress.find(
        (address) => address.id === this.invoiceAddress,
      );
      this.order.invoice_name = address?.name;
      this.order.invoice_zip = address?.zip;
      this.order.invoice_address1 = address?.address1;
      this.order.invoice_address2 = address?.address2;
      this.order.invoice_address3 = address?.address3;
      this.order.invoice_tel = address?.tel;
    }
  }

  public changeInvoiceZip(address) {
    this.order.invoice_address1 = address.pref_name + address.city_name;
    this.changeInput("invoice_address1");
  }

  public clearInvoiceAddress() {
    this.order.invoice_address1 = null;
    this.order.invoice_address2 = null;
    this.order.invoice_address3 = null;
  }

  public changeDestinationAddress() {
    if (this.destinationAddress == this.defaultId) {
      this.order.destination_name =
        this.order?.member?.last_name + " " + this.order?.member?.first_name;
      this.order.destination_zip = this.order?.member?.zip;
      this.order.destination_address1 = this.order?.member?.address1;
      this.order.destination_address2 = this.order?.member?.address2;
      this.order.destination_address3 = this.order?.member?.address3;
      this.order.destination_tel = this.order?.member?.tel;
    } else {
      const address = this.memberAddress.find(
        (address) => address.id === this.destinationAddress,
      );
      this.order.destination_name = address?.name;
      this.order.destination_zip = address?.zip;
      this.order.destination_address1 = address?.address1;
      this.order.destination_address2 = address?.address2;
      this.order.destination_address3 = address?.address3;
      this.order.destination_tel = address?.tel;
    }
  }

  public changeDestinationZip(address) {
    this.order.destination_address1 = address.pref_name + address.city_name;
    this.changeInput("destination_address1");
  }

  public clearDestinationAddress() {
    this.order.destination_address1 = null;
    this.order.destination_address2 = null;
    this.order.destination_address3 = null;
  }

  public formatImageUrl(fileName) {
    return fileName ? formatImageUrl(fileName, "90x90", "contain") : noImage;
  }

  public changeStatus() {
    if (
      this.order.status === STATUSES.CONFIRMED &&
      this.order.payment_type === PAYMENT_TYPES.BANK
    ) {
      const preferredDate = moment(this.order.delivery_preferred_date).subtract(
        1,
        "days",
      );
      const limitDate = moment().add(10, "days");
      if (
        !this.order.payment_limit_date &&
        !this.order.delivery_preferred_date
      ) {
        this.order.payment_limit_date = limitDate.format(DATE_TIME_FORMAT);
      } else if (
        !this.order.payment_limit_date &&
        this.order.delivery_preferred_date
      ) {
        this.order.payment_limit_date = preferredDate.isBefore(limitDate)
          ? preferredDate.format(DATE_TIME_FORMAT)
          : limitDate.format(DATE_TIME_FORMAT);
      }
    }
  }
}
